import React from 'react';
import { Bars } from  'react-loader-spinner'

const Loader = () => {
    
    return (
        <Bars
            height="40"
            width="40"
            color="#4fa94d"
            ariaLabel="bars-loading"
            wrapperStyle={{display: "block"}}
            wrapperClass=""
            visible={true}
        />
    );
};

export default Loader;